import React from "react";
import { isHoffmannVoucherActive } from "utils/hoffmannVoucher";

const OptionPriceDisplay = ({ option, user }) => {
  if (option.priceStruckOnly) {
    const chairVoucherActive = isHoffmannVoucherActive(user, option);
    if (chairVoucherActive || (option.voucherType && !user)) {
      return (
        <div className="option-price option-price--voucher">
          <span className="option-price-struck">
            {option.price} <small>{option.priceNote}</small>
          </span>
          <span className="option-price-voucher-label">Erstbesuch Kostenlos</span>
        </div>
      );
    }
    return (
      <div className="option-price option-price--voucher">
        <span className="option-price-struck">
          {option.price} <small>{option.priceNote}</small>
        </span>
      </div>
    );
  }

  if (option.bookingMode === "consultation" && !option.paidPackage) {
    return (
      <div className="option-price option-price--voucher">
        <span className="option-price-struck">
          {option.price} <small>{option.priceNote}</small>
        </span>
        <span className="option-price-voucher-label">
          Kostenfrei <small>(Erstbesuch)</small>
        </span>
      </div>
    );
  }

  if (option.paidPackage) {
    return (
      <div className="option-price">
        {option.price} <small>{option.priceNote}</small>
      </div>
    );
  }

  const voucherActive = isHoffmannVoucherActive(user, option);

  if (voucherActive || (option.voucherType && !user)) {
    return (
      <div className="option-price option-price--voucher">
        <span className="option-price-struck">
          {option.price} <small>{option.priceNote}</small>
        </span>
        <span className="option-price-voucher-label">
          Kostenfrei <small>(Erstbesuch)</small>
        </span>
      </div>
    );
  }

  return (
    <div className="option-price">
      {option.price} <small>{option.priceNote}</small>
    </div>
  );
};

export default OptionPriceDisplay;
